import React from 'react';
import { Button } from 'react-bootstrap';
import './StudentPositions.css';
import { downloadBlob } from '@/shared/utils/downloadBlob';
import {
    DECIDED_STAGES,
    formatInterviewWhen,
    interviewIcs,
    positionShortName,
} from '@/shared/utils/studentPositions';

/**
 * The interview as the student needs it: when, where, the instructor's note,
 * and a calendar file. Nothing renders when no detail was set, or once the
 * position has a final outcome.
 */
function InterviewBlock({ candidacy }) {
    const { interview, position } = candidacy;
    if (!interview || DECIDED_STAGES.includes(candidacy.stage)) return null;
    const { when, where, details } = interview;
    if (!(when || where || details)) return null;

    const addToCalendar = () => {
        const ics = interviewIcs(candidacy);
        downloadBlob(
            new Blob([ics], { type: 'text/calendar;charset=utf-8' }),
            'interview.ics'
        );
    };

    const rows = [
        when && ['When', formatInterviewWhen(when)],
        where && ['Where', where],
        details && ['Note from the instructor', details],
    ].filter(Boolean);

    return (
        <section
            className="border rounded p-3 mt-2 bg-body-tertiary"
            aria-label={`Interview for ${positionShortName(position)}`}
        >
            <h4 className="h6">Your interview</h4>
            <dl className="row mb-2">
                {rows.map(([label, value]) => (
                    <React.Fragment key={label}>
                        <dt className="col-sm-4">{label}</dt>
                        <dd className="col-sm-8 mb-1 text-break">{value}</dd>
                    </React.Fragment>
                ))}
            </dl>
            {when && (
                <Button
                    variant="outline-primary"
                    size="sm"
                    className="position-action"
                    onClick={addToCalendar}
                >
                    Add to calendar
                    <span className="visually-hidden">
                        {' '}
                        (.ics file) for {positionShortName(position)}
                    </span>
                </Button>
            )}
        </section>
    );
}

export default InterviewBlock;
